/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as techInventoryActions from 'actions/techInventoryActions';
import TechInventory from 'equipmentComponents/TechInventory';
import Footer from 'containers/Footer';
import * as mouseFlowUtils from '../../utils/mouseFlowUtils';
import { TAG_INVENTORY_PAGE } from '../../constants/mouseFlow';

export class InventoryPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleReloadInventory = this
            .handleReloadInventory
            .bind(this);

        mouseFlowUtils.setTag(TAG_INVENTORY_PAGE);
    }

    componentDidMount() {
        const {techData, user, techInventoryActions} = this.props;
        const userId = user.get('userId');
        const inventoryLoading = techData.getIn(['techs', userId, 'inventory', 'loading']);
        const inventoryLoadingFinished = techData.getIn(['techs', userId, 'inventory', 'loadingFinished']);

        const shouldLoad = !inventoryLoading && !inventoryLoadingFinished;

        if (userId && shouldLoad) {

            techInventoryActions.getTechInventoryStarted({
                isSelf: true
            }, userId);
        }
    }

    handleReloadInventory(e) {
        const {user, techInventoryActions} = this.props;
        e.preventDefault();
        const userId = user.get('userId');

        techInventoryActions.getTechInventoryStarted({
            isSelf: true
        }, userId);

    }

    render() {

        const {techData, user, techInventoryActions} = this.props;
        const userId = user.get('userId');
        const inventory = techData.getIn(['techs', userId, 'inventory']);

        return (
            <div><TechInventory
                inventory={inventory}
                isSelf={true}
                userId={userId}
                getTechInventoryStarted={techInventoryActions.getTechInventoryStarted}/>
                <Footer/></div>
        );
    }
}

InventoryPage.propTypes = {
    user: PropTypes.object.isRequired,
    techData: PropTypes.object.isRequired,
    techInventoryActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {

        techData: state.get('techData'),
        user: state.get('user')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryPage);


// WEBPACK FOOTER //
// ./src/containers/pages/InventoryPage.js